import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import { Table, Tag, message, Modal, Descriptions, Image } from 'antd';
import './css/MyOrders.css';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/business/orders/`, {
        withCredentials: true // Include cookies in the request
      });
      console.log('Orders response:', response.data); // Debug log
      setOrders(response.data);
    } catch (error) {
      console.error('Error fetching orders:', error);
      message.error('获取订单数据失败');
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = (record) => {
    console.log('Selected order:', record); // Debug log
    setSelectedOrder(record);
    setModalVisible(true);
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'PENDING':
        return '待处理';
      case 'CONFIRMED':
        return '已确认';
      case 'SHIPPED':
        return '已发货';
      case 'DELIVERED':
        return '已送达';
      case 'CANCELLED':
        return '已取消';
      default:
        return status;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'PENDING':
        return 'gold';
      case 'CONFIRMED':
        return 'blue';
      case 'SHIPPED':
        return 'cyan';
      case 'DELIVERED':
        return 'green';
      case 'CANCELLED':
        return 'red';
      default:
        return 'default';
    }
  };

  const columns = [
    {
      title: '订单号',
      dataIndex: 'order_number',
      key: 'order_number',
    },
    {
      title: '商品',
      key: 'product',
      render: (record) => record.product?.name || '-',
    },
    {
      title: '规格',
      key: 'variation',
      render: (record) => record.product?.variation || '-',
    },
    {
      title: '猫咪',
      key: 'cat',
      render: (record) => record.cat?.name || '-',
    },
    {
      title: '金额',
      dataIndex: 'total_amount',
      key: 'total_amount',
      render: (amount) => `¥${amount}`,
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={getStatusColor(status)}>
          {getStatusText(status)}
        </Tag>
      ),
    },
    {
      title: '下单时间',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => new Date(date).toLocaleString(),
    },
  ];

  return (
    <div className="orders-container">
      <Table 
        columns={columns} 
        dataSource={orders}
        rowKey="order_number"
        loading={loading}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
        })}
        className="orders-table"
      />

      <Modal
        title="订单详情"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={700}
      >
        {selectedOrder && (
          <div className="order-detail">
            <Descriptions bordered column={1}>
              <Descriptions.Item label="订单号">{selectedOrder.order_number}</Descriptions.Item>
              <Descriptions.Item label="商品信息">
                <div className="product-info">
                  {selectedOrder.product?.image_url && (
                    <Image
                      width={100}
                      src={selectedOrder.product.image_url}
                      alt={selectedOrder.product.name}
                      className="product-image"
                    />
                  )}
                  <div>
                    <div>{selectedOrder.product?.name}</div>
                    {selectedOrder.product?.variation && (
                      <div className="variation">规格: {selectedOrder.product.variation}</div>
                    )}
                    <div className="price">单价: ¥{selectedOrder.product?.price}</div>
                  </div>
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="猫咪信息">
                <div className="cat-info">
                  {selectedOrder.cat?.photos?.[0] && (
                    <Image
                      width={60}
                      src={selectedOrder.cat.photos[0]}
                      alt={selectedOrder.cat.name}
                      className="cat-avatar"
                    />
                  )}
                  <div>
                    <div>{selectedOrder.cat?.name}</div>
                    <div>ID: {selectedOrder.cat?.unique_id}</div>
                    {selectedOrder.cat?.breed && (
                      <div>品种: {selectedOrder.cat.breed.name_cn}</div>
                    )}
                  </div>
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="订单金额">¥{selectedOrder.total_amount}</Descriptions.Item>
              <Descriptions.Item label="订单状态">
                <Tag color={getStatusColor(selectedOrder.status)}>
                  {getStatusText(selectedOrder.status)}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="收货地址">{selectedOrder.shipping_address}</Descriptions.Item>
              <Descriptions.Item label="备注">{selectedOrder.notes || '无'}</Descriptions.Item>
              <Descriptions.Item label="下单时间">
                {new Date(selectedOrder.created_at).toLocaleString()}
              </Descriptions.Item>
            </Descriptions>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default MyOrders;
